<template>
    <v-container fluid class="mx-0 px-3">
        <v-card flat class="avsb-card-background">
            <v-card-title class="pl-1 py-2">Users</v-card-title>
        </v-card>

        <!-- Tables -->
        <TableUsers />

        <!-- Dialogs -->
        <DialogUserCreate />
        <DialogUserInvite />
    </v-container>
</template>

<script>
export default {
    components: {
        DialogUserCreate: () =>
            import("@/components/admin/dialogs/dialogUserCreate"),
        DialogUserInvite: () =>
            import("@/components/admin/dialogs/dialogUserInvite"),
        TableUsers: () => import("@/components/admin/tables/tableUsers"),
    },
    methods: {},
    name: "Users",
    // Lifecycle hooks.
    beforeCreate() {},
    created() {},
    beforeMount() {},
    mounted() {},
    beforeUpdate() {},
    updated() {},
    beforeDestroy() {},
    destroyed() {},
};
</script>
